export default {
  mounted() {
    if (this.$getIsApp()) {
      // 获取定位
      window['getCurrentPosition'] = (result) => {
        const data = JSON.parse(
          typeof result === 'string' ? result : JSON.stringify(result)
        );
        if (data.message) {
          this.onLocateFailed(data);
          return;
        }
        this.onLocateSuccess(data);
      };

      this.$callApp('Android', 'CallAppGetPositionMethod', '');
      this.$callApp('iOS', 'CallAppGetPositionMethod', '');
    } else {
      this.onLocateFailed({ message: '定位功能需要访问客户端才能使用' });
      console.warn('非App环境无法获取定位信息');
    }
  },

  beforeDestroy() {
    if (this.$getIsApp()) {
      window['getCurrentPosition'] = undefined;
    }
  },
};
